module.exports = __webpack_public_path__ + "img/illu-bank.3eb25141.svg";